import { match, P } from 'ts-pattern';
import { CalendarYearSingleValueByMonthsSegment } from '../../../api/types-graphql';
import {
  CalendarYearSingleValueByMonthsTimeSelection,
  SingleValueTimeSelection,
  TimeSelectionType,
} from '../../../types';
import { dateShiftedByMonths, dateShiftedByYears, format, getMomentDate } from '../../../utils-date';
import { KpiBenchmarkConfig, KpiFactboxBenchmarkPeriods, KpiQueryConfig } from '../dashboards/types';

const getKpiBenchmarkTimeSelection = (
  mainTimeSelection: SingleValueTimeSelection,
  benchmarkPeriod: KpiFactboxBenchmarkPeriods
): SingleValueTimeSelection => {
  const newTimeSelection: SingleValueTimeSelection = match({ mainTimeSelection, benchmarkPeriod })
    .with(
      {
        benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
        mainTimeSelection: { type: TimeSelectionType.CalendarYearSingleValueByMonths, input: P.select() },
      },
      (input) => {
        // TODO: use better type than the any coming from graphql
        const { start, end } = input;
        const yearOnYearTimeSelectionInput: CalendarYearSingleValueByMonthsSegment = {
          start: format(dateShiftedByYears(getMomentDate(start).valueOf(), -1)),
          end: format(dateShiftedByYears(getMomentDate(end).valueOf(), -1)),
        };
        return {
          type: TimeSelectionType.CalendarYearSingleValueByMonths,
          input: yearOnYearTimeSelectionInput,
        } as CalendarYearSingleValueByMonthsTimeSelection;
      }
    )
    .with(
      {
        benchmarkPeriod: KpiFactboxBenchmarkPeriods.PRIOR_PERIOD,
        mainTimeSelection: { type: TimeSelectionType.CalendarYearSingleValueByMonths, input: P.select() },
      },
      (input) => {
        // TODO: use better type than the any coming from graphql
        const { start, end } = input;
        const priorPeriodTimeSelectionInput: CalendarYearSingleValueByMonthsSegment = {
          start: format(dateShiftedByMonths(getMomentDate(start).valueOf(), -1)),
          end: format(dateShiftedByMonths(getMomentDate(end).valueOf(), -1)),
        };
        return {
          type: TimeSelectionType.CalendarYearSingleValueByMonths,
          input: priorPeriodTimeSelectionInput,
        } as CalendarYearSingleValueByMonthsTimeSelection;
      }
    )
    .otherwise(() => {
      throw new Error(
        `Not yet implemented - Benchmark Period: ${benchmarkPeriod} and main time selection ${mainTimeSelection.type}`
      );
    });
  return newTimeSelection;
};

export const getBenchmarkQueries = (
  mainQuery: KpiQueryConfig,
  benchmarkConfigs: KpiBenchmarkConfig[]
): KpiQueryConfig[] => {
  const { timeSelection } = mainQuery;
  const benchmarkQueries: KpiQueryConfig[] = benchmarkConfigs.map((benchmarkConfig) => {
    const newTimeSelection = getKpiBenchmarkTimeSelection(timeSelection, benchmarkConfig.benchmarkPeriod);
    return {
      ...mainQuery,
      timeSelection: newTimeSelection,
    };
  });
  return benchmarkQueries;
};
